import { configureStore } from "@reduxjs/toolkit"
import { setupListeners } from '@reduxjs/toolkit/query'

import { sentryReduxEnhancer } from "@/lib/utils/sentry"

import { chatsApi } from '@/api/chats/chats.api'
import { patientsApi } from '@/api/patients/patients.api'
import chat from './reducers/chat-reducer'
import notification from './reducers/notification-reducer'
import patients from './reducers/patients-reducer'
import profile from './reducers/profile-reducer'

export const store = configureStore({
  reducer: {
    profile,
    patients,
    chat,
    notification,
    [chatsApi.reducerPath]: chatsApi.reducer,
    [patientsApi.reducerPath]: patientsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(chatsApi.middleware)
      .concat(patientsApi.middleware),
  enhancers: defaultEnhancers => defaultEnhancers.concat(sentryReduxEnhancer)
});

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
